'use client'

import React from 'react'

type Props = {
    tubeRadius: number
    centerRadius: number
}

const WIDTH = 340
const HEIGHT = 220

export default function TorusChart({ tubeRadius, centerRadius }: Props) {
    const outer = centerRadius + tubeRadius
    const scale = 95 / Math.max(outer, 0.0001)
    const R = Math.max(centerRadius * scale, 20)
    const r = Math.max(tubeRadius * scale, 12)

    const cx = WIDTH / 2
    const cy = HEIGHT / 2
    const ryOuter = (R + r) * 0.4
    const ryInner = Math.max(R - r, 0) * 0.4

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* outer boundary */}
            <ellipse cx={cx} cy={cy} rx={R + r} ry={ryOuter} fill="#2563eb" opacity={0.16} stroke="#2563eb" strokeWidth={2} />
            {/* inner hole */}
            <ellipse cx={cx} cy={cy} rx={Math.max(R - r, 0)} ry={ryInner} fill="#ffffff" stroke="#2563eb" strokeWidth={2} />
            {/* tube centerline (dashed) */}
            <ellipse cx={cx} cy={cy} rx={R} ry={R * 0.4} fill="none" stroke="#9ca3af" strokeWidth={1.2} strokeDasharray="4,3" />

            {/* R marker: center to tube centerline */}
            <line x1={cx} y1={cy} x2={cx + R} y2={cy} stroke="#16a34a" strokeWidth={1.5} />
            <text x={cx + R / 2} y={cy - 8} fontSize={11} textAnchor="middle" fill="#16a34a">R = {centerRadius.toFixed(2)}</text>

            {/* r marker: tube centerline to outer edge */}
            <line x1={cx + R} y1={cy} x2={cx + R + r} y2={cy} stroke="#dc2626" strokeWidth={1.5} />
            <text x={cx + R + r / 2} y={cy + 18} fontSize={11} textAnchor="middle" fill="#dc2626">r = {tubeRadius.toFixed(2)}</text>
        </svg>
    )
}
